module.exports = __webpack_public_path__ + "static/img/ys5.78f2c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/ys5.png
// module id = md6+
// module chunks = 0